import React, { useCallback, useState } from 'react';
import { DialogContext, DialogComponent } from './DialogContext';

interface DialogState {
  open: boolean;
  component?: DialogComponent;
  props?: Record<string, unknown>;
}

interface DialogProviderProps {
  readonly children: React.ReactNode;
}

export function DialogsProvider({ children }: Readonly<DialogProviderProps>) {
  const [dialogState, setDialogState] = useState<DialogState>({
    open: false,
  });

  const open = useCallback(
    (Component: DialogComponent, props?: Record<string, unknown>) => {
      setDialogState({ open: true, component: Component, props });
    },
    []
  );

  const close = useCallback(() => {
    setDialogState({ open: false });
  }, []);

  const renderDialog = () => {
    const Component = dialogState.component;
    if (!Component) return null;

    return (
      <Component
        open={dialogState.open}
        onClose={close}
        {...dialogState.props}
      />
    );
  };

  return (
    <DialogContext.Provider value={{ dialogState, open, close }}>
      {children}
      {renderDialog()}
    </DialogContext.Provider>
  );
}
